module.exports = __webpack_public_path__ + "static/media/aspen_logo_animated.9756708c.svg";